import { FC, ReactElement, useEffect, useState } from 'react'
import BaseSelect from 'react-select'

export type OptionType = { label: string, value: number | string | null }

interface SelectProps {
  value: string
  onChange: (val: OptionType) => void
  options: OptionType[]
  placeholder?: string
  isSearchable?: boolean
  isClearable?: boolean
}

export const Select: FC<SelectProps> = ({
  value = null,
  onChange,
  options = [],
  placeholder = '',
  isSearchable = false,
  isClearable = false,
  ...props
}): ReactElement => {
  const [selectedValue, setSelectedValue] = useState<OptionType | OptionType[] | null>(null)

  useEffect(() => {
    if (!value) {
      setSelectedValue(null)
      return
    }

    const initialValue = Array.isArray(value)
      ? options.filter((x) => value.includes(x.value))
      : options.find((x) => value === x.value)

    setSelectedValue(initialValue ?? null)
  }, [options, value])

  const handleChange = (val: OptionType | OptionType[] | null) => {
    const newVal = Array.isArray(val)
      ? val[0] // .map((x) => x.value)[0]
      : val; // ?.value ?? null

    setSelectedValue(val)

    if (!newVal) return;

    onChange(newVal)
  }

  return (
    <BaseSelect
      placeholder={placeholder}
      isMulti={false}
      classNamePrefix='react-select'
      options={options}
      defaultValue={selectedValue}
      value={selectedValue}
      onChange={handleChange}
      components={{ ClearIndicator: null }}
      isSearchable={isSearchable}
      isClearable={isClearable}
      {...props}
    />
  )
}
